import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`To capture an event, use `}<inlineCode parentName="p">{`PostHog.capture/2`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`PostHog.capture("user_signed_up", %{distinct_id: "distinct_id_of_the_user"})
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`PostHog.capture("user_signed_up", %{
  distinct_id: "distinct_id_of_the_user",
  login_type: "email",
  is_free_trial: true
})
`}</code></pre>
    <h3 {...{
      "id": "context"
    }}>{`Context`}</h3>
    <p>{`Carrying `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{` around all the time might not be the most convenient approach, so PostHog lets you store it and other properties in a context.`}</p>
    <p>{`The context is stored in the `}<inlineCode parentName="p">{`Logger`}</inlineCode>{` metadata and PostHog automatically attaches these properties to any events you capture with `}<inlineCode parentName="p">{`PostHog.capture/2`}</inlineCode>{`, as long as they happen in the same process.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`PostHog.set_context(%{distinct_id: "distinct_id_of_the_user"})
PostHog.capture("page_opened")
`}</code></pre>
    <p>{`You can also scope the context to a specific event name:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`PostHog.set_event_context("sensitive_event", %{"$process_person_profile": false})
`}</code></pre>
    <h3 {...{
      "id": "batching-events"
    }}>{`Batching events`}</h3>
    <p>{`Events are automatically batched and sent to PostHog via a background job.`}</p>
    <h3 {...{
      "id": "special-events"
    }}>{`Special events`}</h3>
    <p><inlineCode parentName="p">{`PostHog.capture/2`}</inlineCode>{` is very powerful and enables you to send events that have special meaning.`}</p>
    <p>{`In other libraries you'll usually find helpers for these special events, but they must be explicitly sent in Elixir.`}</p>
    <p>{`For example:`}</p>
    <h4 {...{
      "id": "create-alias"
    }}>{`Create alias`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`PostHog.capture("$create_alias", %{distinct_id: "frontend_id", alias: "backend_id"})
`}</code></pre>
    <h4 {...{
      "id": "group-analytics"
    }}>{`Group analytics`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-elixir"
      }}>{`PostHog.capture("$groupidentify", %{
  distinct_id: "static_string_used_for_all_group_events",
  "$group_type": "company",
  "$group_key": "company_id_in_your_db"
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      